import { render, staticRenderFns } from "./CDLConsultoria.vue?vue&type=template&id=75ff54ed&scoped=true&"
import script from "./CDLConsultoria.vue?vue&type=script&lang=js&"
export * from "./CDLConsultoria.vue?vue&type=script&lang=js&"
import style0 from "./CDLConsultoria.vue?vue&type=style&index=0&id=75ff54ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ff54ed",
  null
  
)

export default component.exports